<template>
  <div>
  <!--Header Components-->
  <base-header class="pb-6" type="">
    <b-row class="align-items-center py-4">
      <!-- <b-col lg="8" cols="12">
        <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
          <route-breadcrumb />
        </nav>
      </b-col>
      <b-col lg="2" v-if="$route.params.id != '_new'">
        <b-link href="javascript:void(0)" @click="viewDocumentMilestones" class="float-right" style="color:#2dce89;">
          <i class="fa fa-anchor mr-2"></i>
          {{language_terms['MILESTONES']}}
        </b-link>
      </b-col> -->
    </b-row>
  </base-header>
  <!--Main Container-->
   <b-container fluid class="mt--6 container-padding">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
       <b-row>
           <b-col cols="12">
                <div class="card-wrapper">
                    <card>
                        <div slot="header" class="mb-0">
                            <b-row>
                              <b-col md="8">
                                <div>
                                    <span style="font-weight: bold">{{ document_title }} </span>
                                </div>
                                <b-dropdown v-if=" (document_mode != 'approval') && 0" :text="language_terms['VIEW_REVISIONS']" class="float-right mr-5" variant="primary" >
                                  <div v-for="(revision, index) in revisions" :key="index">
                                    <b-dropdown-item v-if="revision.is_current == 0" @click="viewRevisionDoc(revision)">
                                        <span v-if="revision.revision != 0">{{language_terms['REVISION']}} {{revision.revision}} - {{revision.time_created}}</span>
                                        <span v-else>{{language_terms['ORIGINAL']}} - {{revision.time_created}}</span>
                                      </b-dropdown-item>
                                      <!-- {{revision.is_current}} -->
                                      <b-dropdown-divider v-if="revision.is_current == 1" ></b-dropdown-divider>
                                      <b-dropdown-item style="background-color:#c3e6cb" active v-if="revision.is_current == 1" @click="viewRevisionDoc(revision)">
                                        {{language_terms['CURRENT']}} - {{revision.time_created}} 
                                      </b-dropdown-item>
                                  </div>
                                </b-dropdown>
                              </b-col>
                              <b-col md="4" v-if="!is_edit">
                                <base-button type="success" @click="addNew" class="float-right">
                                    <i class="fa fa-plus"></i>
                                    <!-- {{language_terms['NEW']}} -->
                                    <!-- {{type == 'SALES' ? language_terms['SALES_RECEIPTS'] : language_terms['PURCHASE_RECEIPTS']}} -->
                                </base-button>
                            </b-col>

                            </b-row>
                        </div>
                        <b-row>
                          <b-col md="7">
                            <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                            <base-input v-model="purchase_document.contact_name" v-if="!is_edit" disabled></base-input>
                              <multiselect
                                :internalSearch = "false"
                                v-if="is_edit"
                                v-model="purchase_document.vendor"
                                id="ajax"
                                label="name"
                                track-by="id"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="vendors"
                                :multiple="false"
                                :searchable="true"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="false"
                                @search-change="asyncFindVendor"
                                @input="onSelectVendor"
                              >
                              </multiselect>
                          </b-col>
                          <b-col md="1" class="mt-3">
                            <b-button class="mt-3" :disabled = "purchase_document.contact_id == null" variant="success" @click="onClickContactSub"><i class="fa fa-arrow-down"></i>
                            </b-button>
                          </b-col>

                          <!-- <b-col md="3">
                            <base-input :label="language_terms['TYPE']">
                                  <el-select
                                      v-model="purchase_document.subtype"
                                      filterable
                                      :placeholder="language_terms['TYPE']"
                                      :disabled="!is_edit">
                                      <el-option
                                          v-for="option in purchase_subtypes"
                                          :key="option.subtype"
                                          :label="language_terms[option.subtype]"
                                          :value="option.subtype">
                                      </el-option>
                                  </el-select>
                            </base-input>
                          </b-col> -->
                          <b-col md="4">
                            <base-input
                              :label="language_terms['ATTENTION']"
                              placeholder="-"
                              v-model="purchase_document.attention_to"
                              :disabled="!is_edit"
                            ></base-input>
                          </b-col>
                          <!-- <b-col md="4" v-if="business_units.length > 1">
                            <base-input :label="language_terms['BUSINESS_UNIT']">
                              <el-select
                                v-model="purchase_document.businessunit_contact_id"
                                filterable
                                :placeholder="language_terms['BUSINESS_UNIT']"
                                :disabled="!is_edit">
                                <el-option
                                  v-for="option in business_units"
                                  :key="option.id"
                                  :label="option.name"
                                  :value="option.id">
                                </el-option>
                              </el-select>
                            </base-input>
                          </b-col> -->
                        </b-row>
                        <b-row class="mt-4">
                            <b-col md="2">
                              <base-input :label="language_terms['REQUESTOR']">
                                <el-select
                                  v-model="purchase_document.requestor_user_id"
                                  filterable
                                  :placeholder="language_terms['REQUESTOR']"
                                  :disabled="!is_edit">
                                  <el-option
                                    v-for="option in salesperson_list"
                                    :key="option.id"
                                    :label="option.name"
                                    :value="option.id">
                                  </el-option>
                                </el-select>
                              </base-input>
                            </b-col>
                            <b-col md="2">
                              <base-input
                                :label="purchase_document.type == 'PI' ? language_terms['VENDOR_INVOICE'] + ' #' : language_terms['REFERENCE']"
                                placeholder="-"
                                v-model="purchase_document.reference"
                                :disabled="!is_edit"
                              ></base-input>
                            </b-col>

                            <b-col md="2" v-if="purchase_document.type == 'PI'">
                              <base-input
                                :label="language_terms['VENDOR'] + ' ' + language_terms['DO'] + ' #'"
                                placeholder="-"
                                v-model="purchase_document.do_reference"
                                :disabled="!is_edit"
                              ></base-input>
                            </b-col>

                            <b-col md="2">
                            <base-input
                              :label="language_terms['EXPENSES_MARKUP'] + ' (%)'"
                              :placeholder="0"
                              v-model="purchase_document.expenses_markup_percent"
                              type="number"
                              :disabled="!is_edit"
                            ></base-input>
                          </b-col>

                            <b-col md="2">
                              <base-input :label="language_terms['DATE']" v-if="is_edit">
                                <flat-picker
                                  slot-scope="{ focus, blur }"
                                  @on-open="focus"
                                  @on-close="blur"
                                  @on-change="onChangeDate"
                                  style="background-color: white"
                                  class="form-control datepicker"
                                  v-model="purchase_document.date">
                                </flat-picker>
                              </base-input>
                              <base-input
                                :label="language_terms['DATE']"
                                v-model="purchase_document.date"
                                v-if="!is_edit"
                                type="date"
                                disabled
                              ></base-input>
                            </b-col>
                            <b-col md="2">
                            <base-input :label="language_terms['CURRENCY']">
                                <el-select
                                  v-model="purchase_document.currency_code"
                                  filterable
                                  :placeholder="language_terms['CURRENCY']"
                                  :disabled="!is_edit">
                                  <el-option
                                    v-for="option in currencies"
                                    :key="option.id"
                                    :label="option.code + ' (' + option.prefix + ')'"
                                    :value="option.code">
                                  </el-option>
                                </el-select>
                            </base-input>
                          </b-col>
                          <b-col md="2">
                            <base-input :label="language_terms['TAX_CODE']">
                              <el-select
                                :disabled="!is_edit || true"
                                :value="purchase_document.tax_code"
                                filterable
                                :placeholder="language_terms['TAX_CODE']"
                                >
                                <el-option
                                  v-for="option in taxes"
                                  :key="option.code"
                                  :label="option.name"
                                  :value="option.code">
                                </el-option>
                              </el-select>
                            </base-input>
                          </b-col>
                          <!-- <b-col md="2" v-if="0">
                            <base-input
                                :label="language_terms['DELIVERY_ETA']"
                                placeholder="YYWW+N"
                                v-model="purchase_document.delivery_eta_yyww"
                                :disabled="!is_edit" 
                              ></base-input>
                          </b-col> -->

                          <b-col md="2" v-if="purchase_document.type == 'PO'">
                            <base-input
                                :label="language_terms['ETD'] + ' (YYWW)'"
                                placeholder="YYWW"
                                v-model="purchase_document.etd_yyww"
                                :disabled="!is_edit" maxlength="4"
                              ></base-input>
                          </b-col>
                          
                          <b-col md="2" v-if="purchase_document.type == 'PO'">
                            <base-input
                                :label="language_terms['ETA'] + ' (YYWW)'"
                                placeholder="YYWW"
                                v-model="purchase_document.eta_yyww"
                                :disabled="!is_edit" maxlength="4"
                              ></base-input>
                          </b-col>

                          <b-col md="2">
                            <base-input :label="language_terms['DELIVERY_MODE']">
                                  <el-select
                                      v-model="purchase_document.delivery_mode"
                                      filterable
                                      placeholder="-"
                                      :disabled="!is_edit">
                                      <el-option
                                          v-for="option in purchase_delivery_modes"
                                          :key="option"
                                          :label="option"
                                          :value="option">
                                      </el-option>
                                  </el-select>
                            </base-input>
                          </b-col>
                          <b-col md="2">
                            <base-input :label="language_terms['DATE_OF_DELIVERY']"  v-if="is_edit">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white"
                                :disabled="!is_edit"
                                class="form-control datepicker"
                                v-model="purchase_document.delivery_date"
                              >
                              </flat-picker>
                            </base-input>
                            <base-input
                              :label="language_terms['DATE_OF_DELIVERY']"
                              v-model="purchase_document.delivery_date"
                              v-if="!is_edit"
                              type="date"
                              disabled>
                            </base-input>
                          </b-col>
                          <b-col md="2">
                            <base-input
                              :label="language_terms['CREDIT_TERMS']"
                              :placeholder="language_terms['CREDIT_TERMS']"
                              v-model="purchase_document.due_days"
                              type="number"
                              @change="onChangeValidityDays"
                              :disabled="!is_edit"
                            ></base-input>
                          </b-col>

                          <b-col md="2" v-if="0">
                            <base-input :label="language_terms['DUE_DATE']"  v-if="is_edit">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white"
                                :disabled="!is_edit"
                                class="form-control datepicker"
                                v-model="purchase_document.due_date"
                              >
                              </flat-picker>
                            </base-input>
                            <base-input
                              :label="language_terms['DUE_DATE']"
                              v-model="purchase_document.due_date"
                              v-if="!is_edit"
                              type="date"
                              disabled>
                            </base-input>
                          </b-col>


                          <b-col :md="($route.params.id != '_new') ? 2: 2" v-if="0">
                            <base-input :label="language_terms['AVAILABLE_CREDIT_LIMIT']" v-model="purchase_document.vendoe_credit_limit_available" disabled></base-input>
                          </b-col>
                          <b-col md="2" v-if="0">
                            <base-input :label="language_terms['CREDIT_LIMIT']" v-model="purchase_document.vendor_credit_limit" disabled></base-input>
                          </b-col>
                          <!-- <b-col md="2">
                            <base-input :label="language_terms['CREDIT_TERMS']" v-model="purchase_document.due_days" disabled></base-input>
                          </b-col> -->
                          <b-col md="2" v-if="$route.params.id != '_new' && 0">
                          <!-- {{language_terms[purchase_document.status]}} -->
                          <base-input :label="language_terms['STATUS']" :value="language_terms[purchase_document.status]" disabled></base-input>
                        </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <base-input :label="language_terms['INSTRUCTIONS']">
                              <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                v-model="purchase_document.remarks"
                                :disabled="!is_edit"
                              ></textarea>
                            </base-input>
                          </b-col>
                          <b-col md="6">
                            <base-input :label="language_terms['INTERNAL_REMARKS']">
                              <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                :disabled="!is_edit"
                                v-model="purchase_document.remarks_internal"
                              ></textarea>
                            </base-input>
                          </b-col>
                        </b-row>
                    </card>
                </div>
           </b-col>
       </b-row>
       <b-row v-if="purchase_document.contact_id">
         <b-col cols="12">
            <div class="card-wrapper">
              <card>
                  <div slot="header" class="mb-0">
                    <h3>{{ language_terms["PURCHASE_ITEMS"] }}</h3>
                  </div>
                  <b-row  v-if="is_edit || 1">
                    <b-col md="12" v-for="(item, index) in purchase_document.items" :key="index">
                       <b-card>
                          <b-row>
                            <b-col md="4">
                                <label class="form-control-label">{{(index + 1) + ". " + language_terms['PRODUCT']}}</label>
                                <productLookup :disabled="!is_edit" v-bind:url="apiProductLookup" v-on:selected="selectProduct($event, index)" :lookupId="item.product_code"/>
                            </b-col>
                            <b-col md="1" class="mb-3">
                              <base-input :label="language_terms['QTY']" v-model="item.qty" type="number"  :disabled="!is_edit" @change="onChangeField(item, index)"></base-input>
                            </b-col>
                            <b-col md="1" class="mb-3">
                              <base-input :label="language_terms['UOM']" >
                                  <el-select :disabled="!is_edit" v-model="item.uom" filterable @change="onChangeField(item, index)">
                                      <el-option v-for="option in item.uom_list"
                                              :key="option.code"
                                              :label="option.code"
                                              :value="option.code">
                                      </el-option>
                                  </el-select>
                              </base-input>
                            </b-col>
                            <b-col md="1" class="mb-3">
                              <base-input :label="language_terms['UNIT_PRICE']" :placeholder="item.unit_price_placeholder" v-model="item.unit_price" type="number" :disabled="!is_edit" @change="onChangeField(item, index)" v-on:keyup.enter="addPurchaseItems"></base-input>
                            </b-col>
                            <b-col md="2">
                                <base-input :label="language_terms['AMOUNT']" v-model="item.gross_amount" type="number" min="0" disabled></base-input>
                            </b-col>
                            <b-col md="1" v-if="!is_edit">
                                <base-input :label="language_terms['REFERENCE']" v-model="item.reference1" disabled></base-input>
                            </b-col>
                            <b-col md="1" class="mb-3" v-if="is_edit">
                              <base-input :label="language_terms['AVAILABLE_QTY']" v-model="item.qty_available" disabled></base-input>
                            </b-col>
                            <b-col md="1" v-if="purchase_document.type == 'PI'">
                                <base-input label="PO" v-model="item.source_document_code" min="0" disabled></base-input>
                            </b-col>
                            <b-col lg="1" class="mt-4 float-right">
                              <base-button :disabled="!is_edit" @click="handleDelete(index, item)" size="sm" icon type="danger" class="mt-3"><i class="fas fa-trash-alt"></i ></base-button>
                              <!-- <base-button @click="handleCollapse(index, item)" size="sm" icon type="success" class="mt-3"><i class="fa fa-angle-down"></i></base-button> -->
                            </b-col>
                            <b-col lg="12" v-if="item.is_trade == '1'">
                                <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                
                                <multiselect
                                  :disabled="!is_edit"
                                  v-model="item.trade_item"
                                  label="product_name"
                                  track-by="product_name"
                                  placeholder="Type to search"
                                  open-direction="bottom"
                                  :options="tradeitem_desp_list"
                                  :multiple="false"
                                  :searchable="true"
                                  :clear-on-select="false"
                                  :close-on-select="true"
                                  :options-limit="300"
                                  :limit="50"
                                  :max-height="600"
                                  :show-no-results="false"
                                  :hide-selected="true"
                                  @search-change="asyncFindTradeItemDesp($event, index)"
                                  :internalSearch = "false"
                                  :taggable="true"
                                  @tag="addTag($event, index)"
                                  @select="onSelectTradeItemDesp($event, index)"
                                />
                          </b-col>
                          </b-row>
                          <b-collapse v-model="item_is_collapsed">
                            <b-row class="mb-3">
                              <b-col md="7"  v-if="item.is_trade == '0'">
                                <base-input :placeholder="item.name" v-model="item.product_name" type="text" :disabled="!is_edit" :label="language_terms['PRODUCT_DESP']"></base-input>
                              </b-col>
                              <b-col md="2"  v-if="item.is_trade == '0'">
                                <base-input :placeholder="item.code" v-model="item.product_code" type="text" disabled :label="language_terms['PRODUCT_CODE']"></base-input>
                              </b-col>
                              

                              <!-- <b-col lg="1" class="mt-4">
                                <b-form-checkbox class="mt-3" v-model="item.has_memo" value="1" unchecked-value="0" :disabled="!is_edit" @change="toggleMemo(item.has_memo, index)">
                                    {{language_terms['MEMO']}}
                                </b-form-checkbox>
                              </b-col> -->
                              <b-col md="1" class="mt-4" v-if="0">
                                <b-form-checkbox class="mt-3" v-model="item.has_memo" value="1" unchecked-value="0" :disabled="!is_edit" @change="toggleMemo(item.has_memo, index)">
                                    {{language_terms['MEMO']}}
                                </b-form-checkbox>
                              </b-col>                                  
                              <b-col md="12" v-if="item.has_memo == 1 || 1">
                                <base-input >
                                  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="item.product_remarks" :disabled="!is_edit"></textarea>
                                </base-input>
                              </b-col>
                            </b-row>
                            <b-row  v-if="purchase_document.type == 'PO' && is_edit">
                              <b-col md="6" v-if="0">
                                <base-input
                                :label="language_terms['DELIVERY_ETA']"
                                placeholder="YYWW+N QTY"
                                v-model="item.delivery_eta_yyww"
                                :disabled="!is_edit"
                                ></base-input>
                              </b-col>

                              <b-col md="3">
                                <base-input
                                :label="language_terms['ETD']"
                                placeholder="YYWW"
                                v-model="item.etd"
                                :disabled="!is_edit" maxlength="4"
                                ></base-input>
                              </b-col>

                              <b-col md="3">
                                <base-input
                                :label="language_terms['ETA']"
                                placeholder="YYWW"
                                v-model="item.eta"
                                :disabled="!is_edit" maxlength="4"
                                ></base-input>
                              </b-col>

                              <b-col md="4">
                                <base-input
                                :label="language_terms['QTY']"
                                placeholder=""
                                v-model="item.eta_qty"
                                :disabled="!is_edit" maxlength="10"
                                ></base-input>
                              </b-col>

                              <b-col md="1" class="mt-3">
                                <base-button :disabled="!is_edit" @click="onClickAddItemSchedule(index, item)" size="sm" icon type="success" class="mt-4"><i class="fas fa-plus"></i ></base-button>
                              </b-col>
                            </b-row>

                            <b-row v-if="purchase_document.type == 'PO' && item.schedules.length > 0">
                              <b-col cols="12">
                                <h4>{{language_terms["DELIVERY_SCHEDULES"]}}</h4>
                              </b-col>                                
                              <b-col md="12">
                                <v-client-table v-model="item.schedules" :columns="itemScheduleColumns" :options="itemScheduleOptions">
                                  <div slot="action" slot-scope="{row}">
                                    <base-button :disabled="!is_edit" @click="onClickDeleteItemSchedule(item, row)" size="sm" icon type="danger" class="mt-3"><i class="fas fa-trash-alt"></i ></base-button>
                                  </div>
                                </v-client-table>                                  
                              </b-col>                                
                            </b-row>
                          </b-collapse>
                       </b-card>
                    </b-col>

                  </b-row>
                  <b-row v-else>
                      <b-col sm="12">
                          <b-table-simple striped hover responsive>
                              <b-thead head-variant="light">
                                <tr>  
                                    <th>{{language_terms['SNO']}}</th>
                                    <th>{{language_terms['PRODUCT_CODE']}}</th>
                                    <th>{{language_terms['PRODUCT']}}</th>
                                    <th>{{language_terms['QTY']}}</th>
                                    <th>{{language_terms['UOM']}}</th>
                                    <!-- <th>{{language_terms['LIST_PRICE']}}</th> -->
                                    <th>{{language_terms['UNIT_PRICE']}}</th>
                                    <th>{{language_terms['AMOUNT']}}</th>
                                    <!-- <th>{{language_terms['TAX_AMOUNT']}}</th> -->
                                    <!-- <th>{{language_terms['NETT_AMOUNT']}}</th> -->
                                </tr>
                              </b-thead>
                              <b-tbody>
                                  <b-tr v-for="(row, index) in purchase_document.items" :key="index">
                                    <td width="20px">{{ row.sno }}</td>
                                    <td>{{row.product_code}}</td>
                                    <td>{{(row.product_name == null || row.product_name == "") ? row.product_name_master : row.product_name}}</td>
                                    <td>{{row.qty}}</td>
                                    <td>{{row.uom}}</td>
                                    <!-- <td>{{row.sale_list_price ? row.sale_list_price : '-'}}</td> -->
                                    <td>{{row.unit_price}}</td>
                                    <td>{{row.gross_amount}}</td>
                                    <!-- <td>{{row.tax_amount}}</td> -->
                                    <!-- <td>{{row.nett_amount}}</td> -->
                                  </b-tr>
                              </b-tbody>
                          </b-table-simple>
                      </b-col>
                  </b-row>

                  <!-- Summary Start -->
                  <b-row>
                    <b-col lg="9"></b-col>
                    <b-col md="3">
                      <b-row class="form-group">
                        <label class="col-md-5 col-form-label form-control-label">{{language_terms['SUB_TOTAL']}}</label>
                        <b-col md="7">
                          <base-input v-model="purchase_document.gross_amount" disabled></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top:-38px">
                    <b-col lg="9"></b-col>
                    <b-col md="3">
                      <b-row class="form-group">
                        <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT_OR_PERCENTAGE']}}</label>
                        <b-col md="7">
                          <base-input v-model="purchase_document.discount_value" :disabled="!is_edit" @change="calDocumentTotal()"></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row  style="margin-top:-38px">
                    <b-col lg="9"></b-col>
                    <b-col md="3">
                      <b-row class="form-group">
                        <label class="col-md-5 col-form-label form-control-label">{{language_terms['DISCOUNT_AMOUNT']}}</label>
                        <b-col md="7">
                          <base-input v-model="purchase_document.discount_amount" disabled></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row  style="margin-top:-38px"> 
                    <b-col lg="9"></b-col>
                    <b-col md="3">
                      <b-row class="form-group">
                        <label class="col-md-5 col-form-label form-control-label">{{language_terms['TAX_AMOUNT']}} 
                          <span>({{this.purchase_document.tax_rate_percent}}%)</span>
                        </label>
                        <b-col md="7">
                          <base-input v-model="purchase_document.tax_amount" disabled></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row  style="margin-top:-38px">
                    <b-col lg="9"></b-col>
                    <b-col md="3">
                      <b-row class="form-group">
                        <label class="col-md-5 col-form-label form-control-label">{{language_terms['GRAND_TOTAL']}}</label>
                        <b-col md="7">
                          <base-input v-model="purchase_document.nett_amount" disabled></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <!-- Summary End -->
              </card>
            </div>
         </b-col>
       </b-row>
           <!-- Show Milestone Modal-->
   <b-modal v-model="milestones_modal" :header-bg-variant="'success'" centered class="my-modal" hide-footer size="md">
      <template #modal-title>
          <span style="color: white;vertical-align: text-bottom;">{{language_terms['MILESTONES']}}</span>
      </template>
      <b-row>
        <b-col cols="12" v-if="milestones.length > 0">
          <ul class="timeline">
            <li v-for="(milestone, index) in milestones" :key="index" :class="getMilestoneClass(milestone)">
              <a href="javascript:void(0)" :style="getMilestoneTxtStyle(milestone)">{{language_terms[milestone.status]}}</a>
              <span class="float-right" style="font-size:small">{{milestone.time_created}}</span>
              <p style="font-size:small">{{milestone.user_name}}</p>
            </li>
          </ul>
        </b-col>
        <b-col sm="12" v-else>
            <div align="center">{{language_terms['NO_DATA_AVAILABLE']}}</div>
        </b-col>
      </b-row>
   </b-modal>

   <b-modal v-model="modalAlternativeContactInfo" :header-bg-variant="'success'" centered hide-footer>
    <template >
      <b-row class="align-items-center mt--2">
        <b-col md="12" fluid class="mt--7">
            <h3 style="color: white;">Additional Contact Info</h3>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col lg="12">
        <base-input
            :label="language_terms['NAME']"
            v-model="purchase_document.alt_contact_name"
            :disabled="!is_edit"
        ></base-input>
      </b-col>
      <b-col lg="12">
        <base-input :label="language_terms['ADDRESS']">
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="5"
            v-model="purchase_document.alt_contact_address"
            :disabled="!is_edit">
          </textarea>
          </base-input>
      </b-col>
    </b-row>
  </b-modal>     

   </b-container>
    <div class="floating-bar">
      <div class="floating-bar-container" align="center">
          <b-button-group>
            <b-button class="transparent-btn" @click="addPurchaseItems"  v-if="((purchase_document.contact_id != null && purchase_document.contact_id != '') && is_edit)">
              <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
            </b-button>
            <b-button class="transparent-btn" @click="editDocument"  v-if="!is_edit && (document_mode != 'approval') && purchase_document.is_locked != 1">
              <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
            </b-button>
            <b-button class="transparent-btn" @click="printDocument" v-if="!is_edit">
              <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
            </b-button>
            <b-button class="transparent-btn" @click="voidDocument" v-if="!is_edit">
              <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['VOID']}}
            </b-button>
            <b-button class="transparent-btn" @click="saveDocument" v-if="is_edit">
              <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}} 
            </b-button>
            <b-button class="transparent-btn" @click="cancelDocument" v-if="is_edit">
              <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
            </b-button>
          </b-button-group>
      </div>
    </div>
  <!--Floating Button-->
  <!-- <div style="width:100%;">
      <a href="javascript:void(0)" class="float-button" @click="cancelDocument" v-if="is_edit" style="background-color:#fb6340">
        <i class="fa fa-times my-float-button"></i>
      </a>
      <a href="javascript:void(0)" class="float-button marginCheck" @click="saveDocument" v-if="is_edit" style="background-color:#5e72e4">
        <i class="fas fa-check my-float-button"></i>
      </a>
  </div> -->
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
// import DatePick from 'vue-date-pick'
import { mapState } from "vuex";
import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";
// import swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.css';

export default {
  props: {
    type: {
      type: String,
      default: "PO",
      description: "Purchase Type",
      required: true,
    },
    title: {
      type: String,
      default: "",
      description: "Purchase Document Title",
      required: true,
    }
  },
  components: { 
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        flatPicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        productLookup,
   },
  computed:{
  ...mapState({
      document_total: state => state.purchase.document_total,
      purchase_doc: (state) => state.purchase.document,
      language_terms: state => state.languages.language_terms,
      business_units: (state) => state.vendors.business_units,
      currencies: (state) => state.currencies.currencies,
      taxes: (state) => state.taxes.taxes,
      taxData: (state) => state.taxes.data,
      uom_list:state => state.products.uom_list, 
      product_price: (state) => state.products.product_purchase_price,
      purchase_is_created: (state) => state.purchase.is_created,
      purchase_is_updated: (state) => state.purchase.is_updated,
      purchase_filter:state => state.purchase.filter,
      salesperson_list:state => state.employees.salesperson_list,
      milestones: state => state.documentMilestones.milestones,
      revisions: state => state.documentRevisions.revisions, 
      revision_is_created: state => state.documentRevisions.revision_created,
      revision_is_retrieved: state => state.documentRevisions.is_retrieved,
      revision_data: state => state.documentRevisions.data,
      purchase_subtypes:state => state.purchase.purchase_subtypes
    }),
  },
  data(){
      return{
        modalAlternativeContactInfo: false,
        code_indicative:"",
        itemScheduleColumns:['etd', 'eta', 'qty', 'action'],
        itemScheduleOptions:{perPage:5, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false},
        // itemScheduleHeaders:['date'],
        purchase_delivery_modes:['WH - LOK YANG','FOB','CIF','CNF','EX-WORK', 'SELF-COLLECTION','OTHERS'],
        item_is_collapsed: true,
        document_mode:null,      
        milestones_modal:false,
        loadingCounter:0,
        document_title:"",
        is_edit:false,
        apiProductLookup: apiRoutes["PRODUCT_LOOKUP_FOR_PURCHASE"],
        vendors:[],
        desp_tags:[],
        tradeitem_desp_list:[],
        selected_business_unit:{id:""},
        purchase_document: {
          code_indicative:'',
          etd_yyww:'',
          eta_yyww:'',
          delivery_eta_yyww: '',
          subtype:"TRADE",
          expenses_markup_percent:0,
          revision_json:{},
          revision_id:null,
          time_printed:null,
          delivery_eta_days:null,
          action_edit:0,
          action_approval:0,
          require_approval:0,
          salesperson_contact_id:null,
          businessunit_contact_id:null,
          vendor_credit_term:null,
          vendor_credit_limit:null,
          vendor_credit_limit_available:null,
          is_locked: 0,
          is_approved: null,
          due_days: 30,
          due_date: null,
          tax_code: "",
          tax_rate_percent: null,
          contact_id: null,
          vendor: {},
          currency_code: "SGD",
          remarks:"",
          remarks_internal:"",
          nett_amount:"",
          gross_amount:"",
          tax_amount:"",
          discount_amount:"",
          items: [
            {
              etd:"", eta:"", eta_qty:"",
              // schedules:[{eta:"", etd:"", qty: 0}],
              schedules:[],
              sno: 1,
              is_trade:0,
              is_collapsed:false,
              reservation_max_days:null,
              trade_item:{},
              uom:"",
              uom_list:[],
              product:{id:"", code:"", name:""},
              bom_components:[],
              product_id: "",
              product_name: "",
              qty: "",
              has_memo:"1",
              product_remarks:null,
              moq:"",
              unit_price: "",
              discount_amount: "",
              tax_amount: "",
              gross_amount: "",
            },
            {
              etd:"", eta:"", eta_qty:"",                    
              schedules:[],                    
              sno: 2,
              is_trade:0,
              is_collapsed:false,
              reservation_max_days:null,
              trade_item:{},
              uom:"",
              uom_list:[],
              product:{id:"", code:"", name:""},
              bom_components:[],
              product_id: "",
              product_name: "",
              qty: "",
              has_memo:"1",
              product_remarks:null,
              moq:"",
              unit_price: "",
              discount_amount: "",
              tax_amount: "",
              gross_amount: "",
            },
            {
              etd:"", eta:"", eta_qty:"",                    
              schedules:[],                    
              sno: 3,
              is_trade:0,
              is_collapsed:false,
              reservation_max_days:null,
              trade_item:{},
              uom:"",
              uom_list:[],
              product:{id:"", code:"", name:""},
              bom_components:[],
              product_id: "",
              product_name: "",
              qty: "",
              has_memo:"1",
              product_remarks:null,
              moq:"",
              unit_price: "",
              discount_amount: "",
              tax_amount: "",
              gross_amount: "",
            }
          ],
          type: null,
        },
      }
  },
  methods:
  {
    async addNew()
    {
      if (this.$props.title == 'Purchase Order')
        window.location.href = '/purchase/purchase-order/_new';
      else      
        window.location.href = '/purchase/purchase-invoice/_new';
    },
    async onClickContactSub()
    {
      this.modalAlternativeContactInfo = true
    },
    async getIndicativeCode()
    {
      let payload = {type: this.type};
      let code = null

      axios.post(apiRoutes["DOCUMENT_GET_CODE"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) 
        {
          code = response.data.msg
          this.code_indicative = code
          if (code != '')
            this.document_title += ' (' + code + ')';
        } 
        else 
        {
          this.purchase_document.code_indicative = ''
        }
      })
      .catch((error) => 
      {
        if (error.response) 
        {
          Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
        } 
      });

      return code
    },      
    async onClickDeleteItemSchedule(item, row)
    {
      for (let x = 0; x < item.schedules.length; x++)
      {
        if (item.schedules[x].id == row.id)
        {
          this.$delete(item['schedules'], x)
          break
        }
      }            
    },
    async onClickAddItemSchedule(index, item)
    {
      let etd = item.etd
      let eta = item.eta
      let qty = item.eta_qty

      if (etd) etd = etd.trim()
      if (eta) eta = eta.trim()
      if (qty) qty = qty.trim()

      let m_w = moment(this.purchase_document.date).format('W')
      let m_y = moment(this.purchase_document.date).format('Y').substr(2,2)
      
      // alert(m_w)
      // alert(m_w.length)
      if (m_w.length == 1)
        m_w = '0' + m_w

      let m_yw = m_y + m_w

      if (etd == '' || eta == '' || etd < m_yw || eta < m_yw || eta < etd 
      || (etd.substr(2,2) < 0 || etd.substr(2,2) > 52) 
      || (eta.substr(2,2) < 0 || eta.substr(2,2) > 52) 
      || parseInt(qty) > parseInt(item.qty)
      )
        alert('Invalid Schedule entry')
      else
      {
        // if (!eta)
        //   eta = etd

        // if (qty == '')
        //   qty = item.qty

        let i = {"etd":etd, "eta":eta, "qty":qty}
        item.schedules.push(i)
        item.etd = ''
        item.eta = ''
        item.eta_qty = ''
      }

    },
    async voidDocument()
    {

      let response =  await this.$confirm('Proceed to void?', this.language_terms['CONFIRMATION'], {
      confirmButtonText: this.language_terms['YES'],
      cancelButtonText: this.language_terms['CANCEL'],
      type: 'warning'
      }).catch(() => {
        //this.$message.info(this.language_terms['ACTION_CANCEL'])
      })

      if (response === 'confirm') {
        let document_id = this.purchase_document.id
        let pv = { id: document_id};
        axios.post(apiRoutes["DOCUMENT_VOID"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            window.location.href = '/purchase/purchase-invoices';
          } 
          else 
          {
            Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
          } 
        });
      }

    },
    printDocument()
    {
      let type = this.purchase_document.type
      let access_token = encodeURIComponent(localStorage.access_token)
      let document_code = encodeURIComponent(this.purchase_document.code)
      let url = ''
      if (type == 'PO')
      {
        url = 'https://reports.unityerp.com/esteam/purchase-order/' + access_token + '/' + document_code
      }
      else if (type  == 'PI')
      {
        url = 'https://reports.unityerp.com/esteam/purchase-invoice/' + access_token + '/' + document_code
      }

      if (url != '')
      {
        let document_id = this.purchase_document.id;
        this.$store.dispatch("documentMilestones/print", {document_id: document_id, });
        this.purchase_document.status = 'LOCKED'
        this.purchase_document.is_locked = 1

        window.open(url , '_blank');
      }
      location.reload();

    },
    async calDocumentTotal()
    {
      await this.$store.dispatch("purchase/cal_document_total", this.purchase_document)
      if(this.document_total)
      {
        this.purchase_document.gross_amount = this.document_total.sub_total.toFixed(2)
        this.purchase_document.nett_amount = this.document_total.nett_amount.toFixed(2)
        this.purchase_document.tax_amount = this.document_total.tax_amount.toFixed(2)
        this.purchase_document.discount_amount = this.document_total.discount_amount.toFixed(2)
        this.purchase_document.tax_rate_percent = this.document_total.tax_rate_percent
      }
  },
  async viewRevisionDoc(revision)
  {
    this.loadingCounter++
    this.revison_modal = false

    if(revision)
    {
      let doc = revision.data_json

      await this.$store.dispatch("documentRevisions/fetch", {revision_id: revision.id});

      if(this.revision_is_retrieved)
      {
          let document_id = `${doc.code} - ${this.language_terms['REVISION']} ${revision.revision}`
          this.document_title = `${this.$props.title} (${document_id})`;

          if(revision.is_current == 1)
          {
              this.is_view_revision = 0
              await this.retrieveDocument(doc.code, this.type)
          }
          else
          {
              this.is_view_revision = 1;
              doc.revision_id = revision.id;
              this.purchase_document = this.revision_data.data_json;
          }
          
        await this.asyncFindVendor(this.purchase_doc.contact_code);
        let selected_vendor = 
        {
          id: this.purchase_document.contact_id,
          code: this.purchase_document.contact_code,
          name: this.purchase_document.contact_name,
          vendor_tax_code: this.purchase_document.contact_vendor_tax_code,
        };

        this.purchase_document.customer = selected_vendor;
        
        if(this.purchase_document.is_approved == 1) 
        {
          this.purchase_document.is_locked = 1;
        }
        let vm = this
        this.purchase_document.items.forEach(function (element, index) {
              element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
              element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
              if(element.is_trade == 1)
              {
                  vm.addTag(element.product_name, index)
              }
        });

      }


    }

    this.loadingCounter--
  },

    editDocument()
    {
      this.is_edit = true
    },
    async retrieveDocument(code, type) {
        await this.$store.dispatch("purchase/fetch", {
          code: code,
          type: type,
        });

        this.purchase_document = this.purchase_doc;
    },
    async asyncFindTradeItemDesp (query, index) 
    {
        let product_id = this.purchase_document.items[index].product_id
        let pv = { value: query, contact_id:this.purchase_document.contact_id, date:"", product_id: product_id};
        axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.tradeitem_desp_list = response.data.data
            Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
          } 
          else 
          {
            this.tradeitem_desp_list = []
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
          } 
        });
  },
  onSelectTradeItemDesp(selectedOption, index)
  {
      if(selectedOption)
      {
        let item = this.purchase_document.items[index]
        item.product_name = selectedOption.product_name
        this.$set(this.purchase_document.items, index , item) 
      }
  },
      getMilestoneTxtStyle(milestone)
  {
      let style = "color:black;font-weight:bold;"

      // if(milestone.status == 'OPEN')
      // {
      //   style = "color:#22c0e8;font-weight:bold;"
      // }
      // else if(milestone.status == 'PENDING_APPROVAL')
      // {
      //   style = "color:#ffc107;font-weight:bold;"
      // }
      // else if(milestone.status == 'APPROVED')
      // {
      //   style = "color:#2dce89;font-weight:bold;"
      // }
      // else if(milestone.status == 'REVISED')
      // {
      //   style = "color:#5603ad;font-weight:bold;"
      // }

      return style
  },
      getMilestoneClass(milestone)
  {
      let classname = 'statusopen';

      if(milestone.status == 'OPEN')
      {
        classname = 'statusopen';
      }
      else if(milestone.status == 'PENDING_APPROVAL')
      {
        classname = 'statuspendingapproval';
      }
      else if(milestone.status == 'APPROVED')
      {
        classname = "statusapproved"
      }
      else if(milestone.status == 'REJECTED')
      {
        classname = "statusrejected"
      }
      else if(milestone.status == 'REVISED')
      {
        classname = "statusrevised"
      }
      return classname
  },
  isFoundInList(name)
  {
      let is_found = 0
      for(let i = 0; i < this.desp_tags.length; i++)
      {
          if(this.desp_tags[i].product_name == name)
          {
            is_found = 1
          }
      }
      return is_found;
  },
  addTag(newTag, index)
  {
    if(newTag)
    {
      let obj = {product_name: newTag, contact_id:this.purchase_document.contact_id, date:this.purchase_document.date}
      if(this.isFoundInList(newTag) == 0)
      {
          this.desp_tags.push(obj)
          // console.log(this.tradeitem_desp_list)
          Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 

          this.purchase_document.items[index].trade_item = obj
          this.purchase_document.items[index].product_name = newTag

      }

    }
  },
    handleCollapse(index, row)
    {
        if(row.is_collapsed)
        {
          row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }


        this.$set(this.purchase_document.items, index , row) 
    },
    handleDelete(index, row) 
    {
      this.purchase_document.items.splice(index, 1);
    },
    addPurchaseItems() 
    {
      let purchase_items_length = this.purchase_document.items.length;

        let item = {
          schedules:[],
          sno: purchase_items_length + 1,
          is_trade:0,
          product:{id:"", code:"", name:""},
          uom:"",
          product_id: "",
          product_name: "",
          qty: "",
          has_memo:"1",
          product_remarks:null,
          sale_list_price:"",
          moq:"",
          unit_price: "",
          discount_amount: "",
          tax_amount: "",
          gross_amount: "",
          uom_list:[],
          is_collapsed:false,
          trade_item:{}
        };

      this.purchase_document.items.push(item);
    },
      async onChangeDate() 
      {
        if (this.purchase_document.date) 
        {
          if (this.purchase_document.tax_code)
          {
            await this.retrieveRate(this.purchase_document.tax_code,this.purchase_document.date);
            this.purchase_document.tax_rate_percent = this.taxData.rate_percent
          }

          this.onChangeValidityDays();
        }
      },
      async onChangeValidityDays() 
      {
        this.purchase_document.due_date = moment(this.purchase_document.date).add(this.purchase_document.due_days, "days").format("YYYY-MM-DD");
      },
      async onChangeField(row, index)
      {
        if (isNaN(row.qty) || row.qty == '')
          row.qty = 1

        if((row.qty || row.unit_price) && row.product_id)
        {
            let unit_price = row.unit_price * 1;

            let product_id = row.product_id
            let qty = row.qty * 1;
            let uom = row.uom; 
            let product_price = await this.retrieveProductPrice(product_id, this.purchase_document.contact_id, qty, uom);

            
            this.purchase_document.items[index].unit_price_placeholder = isNaN(product_price.unit_price) ? 0 : (product_price.unit_price *1)

            if(product_price)
            {
              qty = product_price.qty * 1;
            }


            let gross_amount = product_price.total_amount;

            if(unit_price)
            {
                gross_amount = qty * unit_price;
            }
            this.purchase_document.items[index].qty = qty 
            this.purchase_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)

            await this.calDocumentTotal();
        }
      },
      async asyncFindVendor(query) 
      {
        this.loadingCounter++

        let pv = { value: query };
        await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) {
              this.vendors = response.data.data;
            } else {
              this.vendors = [];
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response);
              Vue.notify({text: error.response, type: "error", group: "notify", max: 5, duration: 5000, speed: 300,});
            } else {
              Vue.notify({text: 'Server error', type: "error", group: "notify", max: 5, duration: 5000, speed: 300,});
            }
          });
          this.loadingCounter--
      },
      async onChangeBusinessUnit()
      {
        if(this.selected_business_unit.id)
        {
          this.purchase_document.contact_id = this.selected_business_unit.id;
          this.purchase_document.contact_code = this.selected_business_unit.code
          this.purchase_document.contact_name = this.selected_business_unit.name

          this.purchase_document.tax_code = this.selected_business_unit.vendor_tax_code;
          await this.onChangeTaxCode(this.selected_business_unit.vendor_tax_code);
        }
      },
      async onSelectVendor(selectedOption)
      {
          if(selectedOption)
          {
              if(selectedOption.id)
              {
                this.selected_business_unit = {id:""}
                await this.$store.dispatch("vendors/fetchBusinessUnits", {parent_id: selectedOption.id});
                if(this.business_units.length > 1)
                {
                    this.purchase_document.businessunit_contact_id = this.business_units[0].id
                    this.purchase_document.contact_id = selectedOption.id;
                }
                else
                {
                    this.purchase_document.contact_id = selectedOption.id;
                    this.purchase_document.tax_code = selectedOption.vendor_tax_code;
                    this.purchase_document.currency_code = selectedOption.currency_code;
                    this.purchase_document.due_days = selectedOption.vendor_credit_term * 1;
                    this.purchase_document.vendor_credit_limit = selectedOption.vendor_credit_limit;
                    this.purchase_document.vendor_credit_limit_available = selectedOption.vendor_credit_limit_available;
                    this.purchase_document.attention_to = selectedOption.contact_person
                    this.purchase_document.expenses_markup_percent = selectedOption.expenses_markup_percent
                    this.purchase_document.subtype = selectedOption.purchase_subtype
                    await this.retrieveRate(this.purchase_document.tax_code, this.purchase_document.date)
                    this.purchase_document.tax_rate_percent = this.taxData.rate_percent
                }

                if (this.$route.params.id == '_new')
                {
                  this.purchase_document.delivery_eta_yyww = selectedOption.default_delivery_eta_yyww
                  this.purchase_document.etd_yyww = selectedOption.default_etd_yyww
                  this.purchase_document.eta_yyww = selectedOption.default_eta_yyww
                  // alert(this.purchase_document.etd_yyww)
                }

              }
          }
      },
      async viewDocumentMilestones()
      {
          await this.$store.dispatch("documentMilestones/fetchAll", {document_id:this.purchase_document.id})
          this.milestones_modal = true
      },
      async retrieveRate(code, date) 
      {
        await this.$store.dispatch("taxes/fetch", { code: code, date: date });
        this.purchase_document.tax_rate_percent = this.taxData.rate_percent;
      },
      async onChangeTaxCode() 
        {
          if (this.purchase_document.tax_code) 
          {
            await this.retrieveRate(
              this.purchase_document.tax_code,
              this.purchase_document.date
            );
            this.purchase_document.tax_rate_percent = this.taxData.rate_percent
          }
        },
      cancelDocument() 
      {
          if(this.$route.params.id == '_new')
          {
            this.routeToMaster()
          }
          else
          {
            location.reload();
          }        
      },
      routeToMaster() 
      {
        if (this.type == "PO") 
        {
          this.$router.push("/purchase/purchase-orders");
        } 
        else if (this.type == "PI") 
        {
          this.$router.push("/purchase/purchase-invoices");
        }
      },
      async saveDocument() 
      {
        if (this.loadingCounter == 0)
        {
          this.loadingCounter++
          if (this.$route.params.id == "_new") 
          {
            let code = this.code_indicative
            this.purchase_document.type = this.type;
            await this.$store.dispatch("purchase/create", this.purchase_document);

            if(this.purchase_is_created)
            {
              // if (code != localStorage.document_code)
              //   alert('Document code is reassigned to\r\n\r\n' + localStorage.document_code)

              await this.searchPurchase();
              this.routeToMaster();
            }
          } 
          else 
          {
            this.purchase_document.type = this.type;
            // await this.$store.dispatch("documentRevisions/create", this.purchase_document);

            // if(this.revision_is_created == "1")
            // {
            //     await this.searchPurchase();
            //     this.routeToMaster();
            // }
            await this.$store.dispatch("purchase/update", this.purchase_document);
            if(this.purchase_is_updated == "1")
            {
                await this.searchPurchase();
                this.routeToMaster();
            }
          }
          this.loadingCounter--
        }
      },
      async reapplyPrices()
      {

      },
      async searchPurchase()
      {
            this.loadingCounter++
            let filter = {
                            keyword:"",
                            date_from:null,
                            date_to:null,
                            type:this.purchase_document.type,
                            status:'ALL'
                          }
            if(this.purchase_filter)
            {
                filter = this.purchase_filter
            }
            await this.$store.dispatch('purchase/quickSearch', filter)

            this.loadingCounter--
        },
      fetchCurrencies() {
        this.$store.dispatch("currencies/fetchAll", {});
      },
      fetchTaxes() {
        this.$store.dispatch("taxes/fetchAll", { type: "Purchase" });
      },
      async getAuthUser()
      {
        await this.$store.dispatch("auth/getAuthUser", {})
      },
      async selectProduct(product, index)
      {
          let item = this.purchase_document.items[index]

          if(product.id)
          {
            this.loadingCounter++

            let product_id = product.id
            let product_code = product.code
            let name = product.name
            let uom = product.uom
            let qty_available = product.qty_available
            let is_trade = product.is_trade
            let product_remarks = product.last_purchase_remarks

            this.purchase_document.items[index].name = name
            if (!this.purchase_document.items[index].is_trade) this.purchase_document.items[index].uom = uom
            this.purchase_document.items[index].qty_available = qty_available
            this.purchase_document.items[index].is_trade = is_trade
            if (this.purchase_document.items[index].product_remarks == null && this.$route.params.id == '_new')
              this.purchase_document.items[index].product_remarks = product_remarks

            // MOQ Display
            let moq = product.moq
            this.purchase_document.items[index].moq_display = (moq !='' && moq != null) ? moq: '-'

            let qty = (this.purchase_document.items[index].qty != '' && this.purchase_document.items[index].qty != null) ? (this.purchase_document.items[index].qty *1) : 0

            //qty = 100;

            // Retrieve UOM List
            let uom_list = await this.retrieveUomList(product_id)
            this.purchase_document.items[index].uom_list = uom_list

            let product_price = await this.retrieveProductPrice(product_id, this.purchase_document.contact_id, qty, uom);

            let unit_price  = this.purchase_document.items[index].unit_price 
            this.purchase_document.items[index].unit_price_placeholder =  isNaN(product_price.unit_price) ? 0 : (product_price.unit_price *1)

            let gross_amount = product_price.total_amount;


            if(unit_price)
            {
              gross_amount = qty * unit_price;
            }

            this.purchase_document.items[index].gross_amount = (gross_amount * 1).toFixed(2)

            this.purchase_document.items[index].product_id = product_id
            this.purchase_document.items[index].product_code = product_code

            let row = this.purchase_document.items[index]
            this.$set(this.purchase_document.items, index , row) 
          
            this.loadingCounter--
          }

      },
      async retrieveUomList(product_id)
      {
          let uom_list = []
          await this.$store.dispatch("products/listUoms", {product_id:product_id})
          if(this.uom_list.length > 0)
          {
              uom_list = this.uom_list
          }

          return uom_list
      },
      async retrieveProductPrice(product_id, vendor_id, qty, uom) 
      {

        await this.$store.dispatch("products/fetchProductPurchasePrice", {
          product_id: product_id,
          contact_id: vendor_id,
          date: this.purchase_document.date,
          qty:qty,
          currency_code: this.purchase_document.currency_code,
          uom:uom
        });


        return this.product_price;
      },
      async viewRevisions()
      {
        await this.$store.dispatch('documentRevisions/fetchAll', {document_id:this.purchase_document.id});

        //this.revison_modal = true

      }
  },
  async mounted()
  {
    this.loadingCounter++
    let document_id = this.$route.params.id;

    await this.$store.dispatch("purchase/getPurchaseSubTypes", {})
    await this.$store.dispatch("employees/fetchAllSalesPerson", {"role_code":"purchase requestor"});

    if(document_id == '_new')
    {
      this.document_title = "New " + this.$props.title;
      await this.getIndicativeCode()

      if(!this.purchase_document.date)
      {
        this.purchase_document.date = moment().format("YYYY-MM-DD");
      }

      this.purchase_document.due_date = moment(this.purchase_document.date).add(this.purchase_document.due_days, "days").format("YYYY-MM-DD");
      if(this.purchase_document.date && this.purchase_document.tax_code)
      {
        this.retrieveRate(this.purchase_document.tax_code, this.purchase_document.date)
        this.purchase_document.tax_rate_percent = this.taxData.rate_percent
      }
      this.purchase_document.remarks = 'PLEASE CHECK AND CONFIRM YOUR (EARLIEST) DELIVERY DATE'
      this.purchase_document.type = this.$props.type 
      this.is_edit = true
    }
    else
    {
        if (this.type && document_id) 
        {
          await this.retrieveDocument(document_id, this.type);
        }
// alert(this.tradeitem_desp_list)
// console.log(this.tradeitem_desp_list)
//this.tradeitem_desp_list.push('XXXALTERNATING CURRENT VOLATAGE TRANSFORMER 230V/110V')
        let title = document_id
        if (this.purchase_document.revision > 0)
          title = title + '-' + this.purchase_document.revision

        this.document_title = `${this.$props.title} (${title})`;
        
        await this.asyncFindVendor(this.purchase_doc.contact_code);

        let selected_vendor = {
          id: this.purchase_document.contact_id,
          code: this.purchase_document.contact_code,
          name: this.purchase_document.contact_name,
          vendor_tax_code: this.purchase_document.contact_vendor_tax_code,
        };

        this.purchase_document.vendor = selected_vendor;

        // if(this.purchase_document.is_approved == 1) 
        // {
        //   this.purchase_document.is_locked = 1;
        // }

        let vm = this
        this.purchase_document.items.forEach(function (element, index) {
              element.product = {id: element.product_id, name: element.product_name_master, code:element.product_code}
              element.trade_item = {product_name: element.product_name, contact_id:null, date:null}
              if(element.is_trade == 1)
              {
                  vm.addTag(element.product_name, index)
              }
        });
      // await this.viewRevisions()
      this.is_edit = false
    }

    await this.fetchCurrencies();
    await this.fetchTaxes();
    await this.getAuthUser()

    this.loadingCounter--
  }
}
</script>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: var(--toolbarHeight);
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>

<style scoped>



.marginCheck{
margin-right:90px;
}
.float-button2
{
  position:fixed;
  width:60px;
  height:60px;
  bottom:40px;
  /* background-color:#0C9; */
  background-color:#2dce89;
  color:#FFF;
  border-radius:50px;
  text-align:center;
  box-shadow: 2px 2px 3px #999;
}
/* .marginPlus{
margin-right:220px;
} */

</style>